import FieldFormatter from './FieldFormatter.vue';
import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'document_id',
      label: i18n.t('common_words.document_number'),
      minWidth: 120,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'card_id',
      label: i18n.t('common_words.card_id'),
      show: false,
    },
    {
      prop: 'business_name',
      label: i18n.t('common_words.company'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'farm_name',
      label: i18n.t('common_words.farm'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'job_name',
      label: i18n.t('common_words.position'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'type_contract.name',
      label: i18n.t('labor.contract'),
      minWidth: 260,
      sortable: true,
      align: 'center',
      formatter: FieldFormatter,
    },
  ];

  return { tableColumns };
};

export default configTable;
